import { createFileRoute, Navigate } from '@tanstack/react-router';

import { RecommendationsSection } from '@apps/web/components/settings/recommendations_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/recommendations')({
    component: RecommendationsPage,
});

function RecommendationsPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Recommendations"
            description="Set default scoring parameters and filters."
        >
            <RecommendationsSection organizationId={organizationId} />
        </SettingsPageShell>
    );
}
